const state = {
    count: 0,
}

const getters = {
    wishlistCount: (state) => {
        return state.count
    },
}

const mutations = {
    updateCount(state, value) {
        state.count = value
    },
}

const actions = {
    updateCount(context, value) {
        context.commit('updateCount', value)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
